import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useCallback } from 'react';

export const useLaunchDarklyContextUpdate = () => {
  const ldClient = useLDClient();

  const updateContext = useCallback(
    newContext => {
      if (ldClient) {
        const currentContext = ldClient.getContext();
        const updatedContext = {
          kind: 'multi',
          ...currentContext,
          ...newContext,
        };
        ldClient.identify(updatedContext);
      }
    },
    [ldClient],
  );

  return updateContext;
};
